import headerTemplate from './templates/header';
import siteCursor from './templates/cursor';
import backToTop from './templates/back-to-top';
import linkWipe from './templates/link-wipe';

export default function templates() {
	headerTemplate();
	linkWipe();
	siteCursor();
	backToTop();
}